function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M24.4479 12.974C24.4479 15.3595 23.7405 17.6913 22.4152 19.6748C21.0899 21.6582 19.2063 23.2041 17.0024 24.1169C14.7986 25.0298 12.3735 25.2686 10.0339 24.8033C7.69431 24.3379 5.54526 23.1892 3.8585 21.5024C2.17175 19.8157 1.02305 17.6666 0.557676 15.327C0.0923009 12.9874 0.331148 10.5624 1.24401 8.35852C2.15688 6.15466 3.70276 4.271 5.68618 2.94572C7.66959 1.62045 10.0015 0.913086 12.3869 0.913086V12.974H24.4479Z",
  fill: "#289C5D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3873 0.913232C14.7727 0.913232 17.1046 1.6206 19.088 2.94587C21.0714 4.27115 22.6173 6.15481 23.5301 8.35866C24.443 10.5625 24.6818 12.9876 24.2165 15.3272C23.7511 17.6668 22.6024 19.8158 20.9156 21.5026C19.2289 23.1893 17.0798 24.338 14.7402 24.8034C12.4006 25.2688 9.97558 25.0299 7.77173 24.1171C5.56787 23.2042 3.68421 21.6583 2.35893 19.6749C1.03366 17.6915 0.326293 15.3596 0.326293 12.9742L12.3873 12.9742L12.3873 0.913232Z",
  fill: "#289C5D"
});

function SvgIcSectorGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSectorGreen);
export default __webpack_public_path__ + "static/media/ic_sector_green.2b0deb5a.svg";
export { ForwardRef as ReactComponent };